import React from 'react';
import { axiosAuth } from './apiBase';

import { handleResponse, handleError } from './response';
const useGCSalarySlabItemsService = () => {
    const getGCSalarySlabItems = async (id) => {
        try {
            const response = await axiosAuth.get(`/api/GCFieldExpences/by-gc-salaryslab-id?gcsalaryslabId=${id}`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    const addGCSalarySlabItems = async (values) => {
        try {
            const response = await axiosAuth.post(`/api/GCFieldExpences`, values);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };

    const updateGCSalarySlabItems = async (id, values) => {
        try {
            const response = await axiosAuth.put(`/api/GCFieldExpences?Id=${id}`, values);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };

    const softDeleteGCSalarySlabItems = async (id) => {
        try {
            const response = await axiosAuth.delete(`/api/GCFieldExpences/soft-delete?Id=${id}`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    return { getGCSalarySlabItems, addGCSalarySlabItems, updateGCSalarySlabItems, softDeleteGCSalarySlabItems };
};

export default useGCSalarySlabItemsService;
